import React, { useState } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_OT0022Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import { fnGetValueByKey } from "../../helpers/functions";
import withRouter from "../../components/Common/withRouter";

const DF_OT0022 = () => {
  console.log("🤖 %cTransação [DF_OT0022]", "color:green");

  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.profile,
  }));

  const [isLoading, setisLoading] = useState(false);
  const [paramsOnFilter, setParamsOnFilter] = useState([]);
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  return (
    <React.Fragment>
      <DF_OT0022Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData,
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_OT0022Context.Provider>
    </React.Fragment>
  );
};

export default withRouter(DF_OT0022);